import { StyledDayLayout, StyledHour } from './styles';
import React from 'react';

type P = {
  authoredAt: string;
  isModify?: boolean;
};

const AuthorAt = ({ authoredAt, isModify }: P) => {
  return (
    <StyledDayLayout>
      {/*임시저장 탭은 createAt이 없음.*/}
      {/*임시 저장은 뒤에 '수정'이 붙도록...*/}
      <StyledHour>{`${authoredAt}${isModify ? ' 수정' : ''}`}</StyledHour>
    </StyledDayLayout>
  );
};

export default AuthorAt;
